<div class="tile-progress bg-white text-left">
  <label>Select Account to configure workflow</label>
  <ng-select style="width:35%" [items]="accounts" (change)="getServiceWorkFlowByAccountId()" name="accounts"
    bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId" [(ngModel)]="accountId">
  </ng-select>
</div>

<!-- Additional Services Modal -->

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Additional Services</h5>
      </div>
      <div class="modal-body" style="padding-top: 20px;">
        <div *ngFor="let items of additionalServicesByParentService">
          <div class="chiller_cb">
            <input [(ngModel)]="items.status" id="{{items.id}}" type="checkbox"
              name="{{getAdditionalServiceName(items.serviceName)}}" />
            <label style="font-weight: normal;"
              for="{{items.id}}">{{getAdditionalServiceName(items.serviceName)}}</label>
            <span></span>
          </div>
        </div>
      </div>
      <div class="modal-footer" style="padding:8px;">
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="closeModal()"
          style="background-color: #A1630D;">Close</button>
          <!-- <button type="button" class="btn btn-primary" >Save changes</button> -->
      </div>
    </div>
  </div>
</div>
<!-- Modal End Here -->

<div *ngIf="accountId!=null && accountId>0">

  <div class="card-header">
    <span>Workflows</span>
  </div>

  <div class="content-body padding-top-20 padding-bottom-20 ">
    <div class="row">
      <table class="table table-borderless">
        <thead style="background: #f0f2f5;">
          <tr>
            <td>Service Order</td>
            <td>Service Name</td>
            <td>Enable/Disable Service</td>
            <td>Is Mandatory?</td>
            <td>Additional Services</td>
          </tr>
        </thead>
        <tbody [sortablejs]="serviceWorkFlow" [sortablejsOptions]="draggableOptions">
          <tr style="cursor: pointer;" *ngFor="let workflow of serviceWorkFlow; let i = index"
            [class.draggable]="workflow.draggable" [class.disabled]="!workflow.draggable">
            <td>{{ i + 1 }}</td>
            <td>{{getServiceName(workflow.serviceId) }}</td>
            <td>
              <div class="chiller_cb">
                <!--<input [attr.name]="getServiceName(workflow.serviceId)"
                  [disabled]="workflow.serviceName == 'SPECTACLE'"
                  #{{getServiceName(workflow.serviceId)}}="ngModel" [attr.id]="getServiceName(workflow.serviceId)"
                  [(ngModel)]="workflow.status" type="checkbox" />-->
                <input [attr.name]="getServiceName(workflow.serviceId)"
                  #{{getServiceName(workflow.serviceId)}}="ngModel" [attr.id]="getServiceName(workflow.serviceId)"
                  [(ngModel)]="workflow.status" type="checkbox" />
                <label style="font-weight: normal;" for={{getServiceName(workflow.serviceId)}}>Select if
                  Enabled</label>
                <span></span>
              </div>
            </td>
            <td>
              <div class="chiller_cb">
                <!--<input [(ngModel)]="workflow.isMandatory" #{{workflow.serviceId}}="ngModel"
                  [disabled]="workflow.serviceName == 'SPECTACLE'" [attr.name]="workflow.serviceId"
                  [attr.id]="workflow.serviceId" type="checkbox" />-->
                <input [(ngModel)]="workflow.isMandatory" #{{workflow.serviceId}}="ngModel"
                  [attr.name]="workflow.serviceId" [attr.id]="workflow.serviceId" type="checkbox" />
                <label style="font-weight: normal;" for={{workflow.serviceId}}>Select if Mandatory</label>
                <span></span>
              </div>
            </td>
            <!-- <td>
                  <div class="chiller_cb">
                    <input [(ngModel)]="workflow.isEnabled" id="{{ 'service_enabled' + i }}" name="{{ 'service_enabled' + i }}" type="checkbox"
                    />
                    <label style="font-weight: normal;"></label>
                    <span></span>
                  </div>

                </td>
                <td>
                  <div class="chiller_cb">
                    <input [(ngModel)]="workflow.isMandatory" id="{{ 'service_mandatory' + i }}" name="{{ 'service_mandatory' + i }}" type="checkbox"
                    />
                    <label style="font-weight: normal;"></label>
                    <span></span>
                  </div>

                </td> -->
            <td class="additional_service_class" *ngIf="workflow.serviceName == 'REFRACTION' || workflow.serviceName == 'DOAAS'">
              <div class="chiller_cb">
                <input [(ngModel)]="workflow.isAdditionalServiceEnabled" id="isAdditionalServiceEnabled+{{i}}"
                  type="checkbox" name="isAdditionalServiceEnabled" (change)="showAdditionalServicesPopUp(workflow.serviceName, workflow.isAdditionalServiceEnabled)" />
                <label style="font-weight: normal;" for="isAdditionalServiceEnabled+{{i}}">Additional Services</label>
                <span></span>
              </div>

              <div [hidden]="!workflow.isAdditionalServiceEnabled" class="margin-left-1">
                <button class="btn btn-success" (click)="showAdditionalServicesPopUp(workflow.serviceName, workflow.isAdditionalServiceEnabled)"> View </button>
              </div>
              <!-- <small data-toggle="modal" data-target="#exampleModalCenter"
                (click)="getServiceId(workflow.serviceId)">View</small> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div class="col-xs-12 text-center">
        <button class="btn btn-sm marginLR5"
          style="background-color: rgb(87,200,231);color: white;height:38px;font-size: 14px;"
          (click)="saveWorkflowSettings()">
          <i class="fa fa-fw fa-lg fa-check-circle"></i>
          Save Workflow Settings</button>
      </div>
    </div>
  </div>
</div>